module.exports = __webpack_public_path__ + "static/solidarity-labs-3-0d7fdd449b4783207a64257a9ad668b2.jpg";